import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-center position-relative'
      style={{
        minHeight: '100%',
        backgroundImage: `url(${toAbsoluteUrl('/media/auth/bg-image.svg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* begin::Card */}
      <div
        className='card shadow w-100 mx-4 position-relative'
        style={{maxWidth: 460, borderRadius: 24}}
      >
        <div className='card-body p-10 p-md-12'>
          <Outlet />
        </div>
      </div>
      {/* end::Card */}
    </div>
  )
}

export {AuthLayout}
